module.exports = __webpack_public_path__ + "img/9788954437127.c91ee6f3.jpg";